import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Anvisat = lazy(() => import("@/pages/elavtal/Anvisat"));

export const Route = createFileRoute("/elavtal/anvisat")({
  head: () => seoHead("/elavtal/anvisat", { description: "Ett anvisat elavtal får du automatiskt om du inte själv valt elhandlare. Det är oftast Sveriges dyraste elavtal – byt så fort du kan." }),
  component: () => <Anvisat />,
});
